import PropTypes from 'prop-types';
import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuth from 'hooks/useAuth';
import Login from 'pages/authentication/Login';
import { PATH_APP } from 'routes/paths';
import { isMobeatStaff } from 'utils/mobeatStaff';

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default function AuthGuard({ initializeAppId, children }) {
  const { isAuthenticated, user } = useAuth();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Login />;
  }

  if (pathname === '/') {
    return (
      <Navigate to={isMobeatStaff(user?.organizationRole) ? PATH_APP.admin.demoLeads : '/admin/overview'} replace />
    );
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
